import { FC } from 'react';

import { IModuleSliderArrowProps, ModuleSliderArrow } from '~modules/slider/ModuleSliderArrow';

export const ModuleSliderNextArrow: FC<Omit<IModuleSliderArrowProps, 'direction'>> = props => (
  <ModuleSliderArrow {...props} direction="right" />
);
export default ModuleSliderNextArrow;
